var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.stepActive !== 2|| _vm.finish)?_c('button',{staticClass:"mk-continue",on:{"click":_vm.nextStep}},[_vm._v(" "+_vm._s(_vm.$t('visualization.continue'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }